<template>
  <div>
    <FormSectionTitle
      :title="$t(`BRAND.DESCRIPTORS.${data.title}`)"
      :description="data.description != null ? $t(`BRAND.DESCRIPTORS.${data.description}`) : null"
      :moaSpecific="data.moa_setting"
      :filled="filled"
    />

    <InputGenericRadioOption
      class="pl-5 mb-10"
      :id="`special-link-rich-alt-${option}`"
      :model="$v.selectedOption"
      :options="options"
      :submissionStates="submissionStates"
      :error="$t('FORMS.GENERIC_ERRORS.REQUIRED')"
      :displayLabel="false"
      :slim="true"
    >
    </InputGenericRadioOption>

    <InputGeneric
      v-if="selectedOption == 1"
      :id="`special-link-rich-alt-${option}-link`"
      :model="$v.link"
      alignLabel="left"
      :placeholder="$t('FORMS.INPUTS.URL')"
      :submissionStates="submissionStates"
      :showInline="true"
      error="This field must be a valid URL"
      type="text"
      class="px-3"
    >
    </InputGeneric>

    <div v-if="selectedOption == 2" class="px-3 mx-0">
      <InputGenericRichText
        :id="`special-link-rich-alt-${option}-rich`"
        :model="$v.rich"
        :submissionStates="submissionStates"
        :error="$t('FORMS.ERROR.REQUIRED')"
      >
      </InputGenericRichText>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { url, requiredIf, minValue } from "vuelidate/lib/validators";

import FormSectionTitle from "@/view/components/FormSectionTitle";
import InputGenericRadioOption from "@/modules/together-helpers/components/generic-inputs/GenericRadioOption";
import InputGeneric from "@/view/components/form-inputs/GenericInput";
import InputGenericRichText from "@/view/components/form-inputs/GenericRichText";

export default {
  mixins: [validationMixin],

  name: "SpecialLinkRichAlt",

  props: {
    data: { type: Object, required: true },
    option: { type: Number, required: true },
    submissionStates: { type: Object, required: true }
  },

  data() {
    return {
      options: [
        { text: `${this.$t('BRAND.OPTIONS.NEITHER_LINK_OR_RICH')}`, value: null},
        { text: `${this.$t('BRAND.OPTIONS.LINK')}`, value: 1 },
        { text: `${this.$t('BRAND.OPTIONS.TEXT')}`, value: 2 }
      ],
      selectedOption: 1,
      link: "",
      rich: ""
    }
  },

  validations: {
    selectedOption: {},
    link: {
      url,
      required: requiredIf(function() {
        return this.selectedOption == 1;
      })
    },
    rich: {
      required: requiredIf(function() {
        return this.selectedOption == 2;
      })
    }
  },

  components: {
    FormSectionTitle,
    InputGenericRadioOption,
    InputGeneric,
    InputGenericRichText
  },

  watch: {
    selectedOption: {
      handler(newVal) {
        this.form[this.option].value = newVal;
      }
    },
    link: {
      handler(newVal) {
        this.form[this.option].options.link = newVal;
      }
    },
    rich: {
      handler(newVal) {
        this.form[this.option].options.message = newVal;
      }
    },
    entry: {
      handler(newVal) {
        this.selectedOption = newVal.value;
        this.link = newVal.options.link;
        this.rich = newVal.options.message;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters([
      "projectInfo"
    ]),
    ...mapState({
      form: state => state.projectBrands.project_brand_form
    }),
    entry: function() {
      return this.form[this.option];
    },
    filled: function() {
      return (this.selectedOption == 1 && this.$v.link.$anyError == false || this.selectedOption == 2 && this.rich != null && this.rich.length > 0) ? true : false;
    }
  }
}
</script>